import React from 'react';
import { PolicyLink } from './style';

export function AppFooterPolicy() {
  const policyLink = 'https://petrovichclub.ru/upload/pages/docs/politika.pdf';

  return (
    <PolicyLink href={policyLink} target="_blank">
      Политика конфиденциальности
    </PolicyLink>
  );
}
